import Vue from 'vue'
import VueI18n from 'vue-i18n';
//多语言文件


Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: localStorage.getItem('language') || 'zh-cn', 
    messages: {
        'zh-cn': require('@/language/zh.json'),
        'en': require('@/language/en.json'),
    }
})

export default i18n